import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
} from "recharts";

export default function PhaseReactiveEnergyBars({ deviceId, API_BASE }) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  useEffect(() => {
    async function load() {
      try {
        // 🔥 Import Reaktif Enerji
        const resImp = await fetch(
          `${API_BASE}/measurements/energy/import-reactive?deviceId=${deviceId}`
        );
        const imp = await resImp.json();

        // 🔥 Export Reaktif Enerji
        const resExp = await fetch(
          `${API_BASE}/measurements/energy/export-reactive?deviceId=${deviceId}`
        );
        const exp = await resExp.json();

        const rows = [
          {
            phase: "L1",
            importVal: Math.trunc(((imp.Q1_IMPORT ?? 0) / 1000) * 1000) / 1000,
            exportVal: Math.trunc(((exp.Q1_EXPORT ?? 0) / 1000) * 1000) / 1000,

          },
          {
            phase: "L2",
            importVal: Math.trunc(((imp.Q2_IMPORT ?? 0) / 1000) * 1000) / 1000,
            exportVal: Math.trunc(((exp.Q2_EXPORT ?? 0) / 1000) * 1000) / 1000,

          },
          {
            phase: "L3",
            importVal: Math.trunc(((imp.Q3_IMPORT ?? 0) / 1000) * 1000) / 1000,
            exportVal: Math.trunc(((exp.Q3_EXPORT ?? 0) / 1000) * 1000) / 1000,

          },
        ];

        setData(rows);
      } catch (err) {
        console.error("PhaseReactiveEnergyBars error:", err);
      }
    }

    load();
    const int = setInterval(load, 15000);
    return () => clearInterval(int);
  }, [deviceId, API_BASE]);

  return (
    <div className="bg-white p-5 border border-slate-200 rounded-xl shadow-sm">
      <h3 className="text-sm font-semibold text-slate-700 mb-3">
        {t('energies.phaseReactiveTitle')}
      </h3>

      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis dataKey="phase" stroke="#6B7280" />
            <YAxis stroke="#6B7280" />
            <Tooltip formatter={(v) => `${v.toFixed(3)} kVArh`} />
            <Legend />

            {/* Import – Export barları */}
            <Bar dataKey="importVal" name={t('energies.importkVArh')} fill="#3B82F6" />
            <Bar dataKey="exportVal" name={t('energies.exportkVArh')} fill="#F59E0B" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
